// Per-env settings read from /config.json at start-up (written by Terraform,
// infra/modules/frontend), so one build serves every env. Local runs read
// public/config.json: copy public/config.example.json and fill it in.
//
// Keys: region, userPoolId, userPoolWebClientId, apiBaseUrl, passwordPolicy
// ({ minLength, characters }), vmsDomain (VMS handoff).
let config = null;

export async function loadRuntimeConfig() {
  const res = await fetch("/config.json", { cache: "no-store" });
  if (!res.ok) throw new Error(`config.json: HTTP ${res.status}`);
  config = await res.json();
  return config;
}

export default function runtimeConfig() {
  if (!config) throw new Error("runtime config is not loaded yet");
  return config;
}
